import { render, staticRenderFns } from "./inativarEstrutura.vue?vue&type=template&id=11d02d18"
import script from "./inativarEstrutura.vue?vue&type=script&lang=js"
export * from "./inativarEstrutura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports